import { Grid, Typography, Box, Button, TextField } from "@material-ui/core";
import { useMountAPI } from "../hooks/APICall";
import {
  WHITE,
  GREEN_PRIMRY,
  BLUE_COLOR,
  ERROR_COLOR,
  ORANGE_COLOR,
  BLUE_PRIMARY,
} from "../utils/const";
import Call from "../service/API";
import useCustomState from "../hooks/State";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { convertNumbers } from "../utils/ConvertNumbers";
import Loading from "../components/loading";
import SuccessModal from "../components/generalModals/SuccessModal";
import moment from "jalali-moment";
import { Split } from "../utils/Split";
import InfoIcon from "@material-ui/icons/Info";
import SayalLogo from "../assets/img/sayal-logo.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { daysBetweenDates } from "../utils/TimeUtils";
import Num2persian from "num2persian";
import { IndeterminateCheckBoxTwoTone } from "@material-ui/icons";

const BillInfo = (props) => {
  const counterSerial = props.match.params.counterSerial;
  const billSerial = props.match.params.billId;

  const successModalOpen = useCustomState(false);
  const successTitle = useCustomState("");
  const successMessage = useCustomState("ثبت اطلاعات با موفقیت انجام شد.");
  const successStyle = useCustomState({ successColor: GREEN_PRIMRY });

  const billTextBackground = "#e6f7ff";

  const openSuccessModal = () => {
    successModalOpen.handleChange(true);
  };

  const billInfoIsLoading = useCustomState(true);
  const billInfo = useCustomState({ category: "" });

  const billUtils = {
    billId: null,
    billSerial: billSerial,
    billInfo: billInfo,
    isLoading: billInfoIsLoading,
  };

  useMountAPI(fetchBillInfo, billUtils);

  const downloadBill = () => {
    const width = Math.floor((16 * window.innerWidth) / 1396);
    const height = Math.floor((7 * window.innerHeight) / 656);
    const input = document.getElementById("bill");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "in",
        format: [36, 12],
      });
      pdf.addImage(imgData, "JPEG", 0, 0);
      //   pdf.output("dataurlnewwindow");
      const now = moment().locale("fa").format("YYYY-MM-DD_HH:mm:ss");
      pdf.save("bill_" + billSerial + "_T" + now + "_.pdf");
    });
  };

  const renderBillHeader = () => {
    return (
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ height: "55px", borderBottom: "1px solid #333333" }}
        >
          <div
            style={{
              position: "relative",
              height: "55px",
            }}
          >
            <img
              style={{ position: "absolute", right: 0 }}
              src={SayalLogo}
              width={60}
              height={50}
            />
            <span
              style={{
                position: "absolute",
                right: "65px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              شرکت سیال سنجش
            </span>
          </div>
        </Grid>
      </Grid>
    );
  };

  const renderUserInfo = () => {
    return (
      <Grid
        container
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "8px",
          paddingBottom: "8px",
        }}
      >
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Typography>
            <span style={{ fontSize: "12px" }}>مشترک گرامی: </span>
            <span style={{ fontSize: "14px" }}>{billInfo.value.user.name}</span>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Typography>
            <span style={{ fontSize: "12px" }}>کد پستی: </span>
            <span style={{ fontSize: "14px" }}>
              {convertNumbers(billInfo.value.user.postalCode)}
            </span>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Typography>
            <span style={{ fontSize: "12px" }}>تاریخ صدور قبض: </span>
            <span style={{ fontSize: "14px" }}>
              {convertNumbers(
                moment(billInfo.value.createdDate)
                  .locale("fa")
                  .format("YYYY/MM/DD")
              )}
            </span>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}></Grid>

        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Typography>
            <span style={{ fontSize: "12px" }}>شماره تلفن: </span>
            <span style={{ fontSize: "14px" }}>
              {convertNumbers(billInfo.value.user.phoneNumber)}
            </span>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <span style={{ fontSize: "12px" }}>نشانی: </span>
          <span style={{ fontSize: "14px" }}>
            {convertNumbers(billInfo.value.user.address)}
          </span>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}></Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}></Grid>
      </Grid>
    );
  };

  const renderPeriod = () => {
    return (
      <Grid
        container
        style={{ paddingRight: "2px", paddingLeft: "1px", paddingTop: "2px" }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            border: "1px solid #333333",
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            backgroundColor: billTextBackground,
          }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px", fontWeight: "bold" }}>دوره</span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{ border: "1px solid #333333" }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>از تاریخ</span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{ border: "1px solid #333333" }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>تا تاریخ</span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            border: "1px solid #333333",
            borderBottomRightRadius: "8px",
          }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>
              {convertNumbers(
                moment(billInfo.value.from).locale("fa").format("YYYY/MM/DD")
              )}
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{ border: "1px solid #333333", borderBottomLeftRadius: "8px" }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>
              {convertNumbers(
                moment(billInfo.value.to).locale("fa").format("YYYY/MM/DD")
              )}
            </span>
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderCounterInfo = () => {
    return (
      <Grid
        container
        style={{ paddingRight: "2px", paddingLeft: "1px", paddingTop: "2px" }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            border: "1px solid #333333",
            borderTopRightRadius: "8px",
            backgroundColor: billTextBackground,
          }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px", fontWeight: "bold" }}>
              سریال کنتور
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            border: "1px solid #333333",
            borderTopLeftRadius: "8px",
            backgroundColor: billTextBackground,
          }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px", fontWeight: "bold" }}>
              وضعیت کنتور
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            border: "1px solid #333333",
            borderBottomRightRadius: "8px",
          }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>
              {convertNumbers(billInfo.value.counterInfo.serial)}
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{ border: "1px solid #333333", borderBottomLeftRadius: "8px" }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>
              {billInfo.value.counterInfo.status}
            </span>
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderConsumption = () => {
    return (
      <Grid
        container
        style={{ paddingRight: "2px", paddingLeft: "1px", paddingTop: "2px" }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            border: "1px solid #333333",
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            backgroundColor: billTextBackground,
          }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px", fontWeight: "bold" }}>مصرف</span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          style={{ border: "1px solid #333333" }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>طول دوره (روز)</span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          style={{ border: "1px solid #333333" }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>مصرف دوره</span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          style={{ border: "1px solid #333333" }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>میانگین مصرف</span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          style={{
            border: "1px solid #333333",
            borderBottomRightRadius: "8px",
          }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>
              {convertNumbers(billInfo.value.periodDays)}
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          style={{ border: "1px solid #333333" }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>
              {convertNumbers(billInfo.value.consumptions)}
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          style={{ border: "1px solid #333333", borderBottomLeftRadius: "8px" }}
        >
          <Typography align="center">
            <span style={{ fontSize: "12px" }}>
              {convertNumbers(billInfo.value.avgConsumption)}
            </span>
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderPriceWithLetters = () => {
    return (
      <Grid
        container
        style={{ paddingRight: "2px", paddingLeft: "1px", paddingTop: "2px" }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            border: "1px solid #333333",
            paddingRight: "8px",
            paddingLeft: "8px",
            paddingTop: "8px",
            paddingBottom: "8px",
            borderRadius: "8px",
            backgroundColor: billTextBackground,
          }}
        >
          <Typography style={{ fontSize: "14px", fontWeight: "bold" }}>
            مبلغ به حروف
          </Typography>
          <Typography style={{ fontSize: "14px", fontWeight: "bold" }}>
            {/* دویست و پنجاه و پنج هزار و ششصد و هفتاد ریال */}
            <span>{Num2persian(billInfo.value.price)}</span>
            <span>{" ریال"}</span>
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderRightSection = () => {
    return (
      <>
        {renderPeriod()}
        {renderCounterInfo()}
        {renderConsumption()}
        {renderPriceWithLetters()}
      </>
    );
  };

  const renderDescriptionSection = () => {
    return (
      <Grid
        container
        style={{
          paddingRight: "1px",
          paddingLeft: "1px",
          paddingTop: "2px",
          height: "231px",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ border: "1px solid #333333", borderRadius: "8px" }}
        ></Grid>
      </Grid>
    );
  };

  const renderBillId = () => {
    return (
      <Grid
        container
        style={{ paddingRight: "1px", paddingLeft: "1px", paddingTop: "2px" }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            border: "1px solid #333333",
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            backgroundColor: billTextBackground,
          }}
        >
          <Typography
            align="center"
            style={{ fontSize: "12px", fontWeight: "bold" }}
          >
            شناسه قبض
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            border: "1px solid #333333",
            borderBottomRightRadius: "8px",
            borderBottomLeftRadius: "8px",
          }}
        >
          <Typography
            align="center"
            style={{ fontSize: "14px", fontWeight: "bold" }}
          >
            {convertNumbers(billInfo.value.serial)}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderMiddleSection = () => {
    return (
      <>
        {renderDescriptionSection()}
        {renderBillId()}
      </>
    );
  };

  const renderPriceTable = () => {
    return (
      <Grid
        container
        style={{
          paddingRight: "1px",
          paddingLeft: "2px",
          paddingTop: "2px",
          height: "231px",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            border: "1px solid #333333",
            borderTopRightRadius: "8px",
            borderBottomRightRadius: "8px",
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{
                borderBottom: "1px solid #333333",
                backgroundColor: billTextBackground,
                borderTopRightRadius: "8px",
              }}
            >
              <Typography
                align="center"
                style={{ fontSize: "12px", fontWeight: "bold" }}
              >
                شرح
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ paddingRight: "8px", paddingTop: "8px" }}
            >
              <Typography style={{ fontSize: "14px" }}>
                بهای میزان مصرف
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ paddingRight: "8px", paddingTop: "8px" }}
            >
              <Typography style={{ fontSize: "14px" }}>بهای خدمات</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ paddingRight: "8px", paddingTop: "8px" }}
            >
              <Typography style={{ fontSize: "14px" }}>
                مالیات بر ارزش افزوده
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{
                paddingRight: "8px",
                paddingTop: "8px",
                marginTop: "75px",
              }}
            >
              <Typography style={{ fontSize: "14px" }}>
                جمع صورتحساب دوره:
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            border: "1px solid #333333",
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px",
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{
                borderBottom: "1px solid #333333",
                backgroundColor: billTextBackground,
                borderTopLeftRadius: "8px",
              }}
            >
              <Typography
                align="center"
                style={{ fontSize: "12px", fontWeight: "bold" }}
              >
                مبلغ (ریال)
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ paddingTop: "8px" }}
            >
              <Typography align="center" style={{ fontSize: "14px" }}>
                {convertNumbers(Split(billInfo.value.price))}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ paddingTop: "8px" }}
            >
              <Typography align="center" style={{ fontSize: "14px" }}>
                {convertNumbers(Split(0))}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ paddingTop: "8px" }}
            >
              <Typography align="center" style={{ fontSize: "14px" }}>
                {convertNumbers(Split(0))}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ paddingTop: "8px", marginTop: "75px" }}
            >
              <Typography align="center" style={{ fontSize: "14px" }}>
                {convertNumbers(Split(billInfo.value.price))}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderDeadline = () => {
    return (
      <Grid
        container
        style={{ paddingRight: "1px", paddingLeft: "2px", paddingTop: "2px" }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            border: "1px solid #333333",
            borderTopRightRadius: "8px",
            backgroundColor: billTextBackground,
          }}
        >
          <Typography
            align="center"
            style={{ fontSize: "12px", fontWeight: "bold" }}
          >
            مهلت پرداخت
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            border: "1px solid #333333",
            borderTopLeftRadius: "8px",
            backgroundColor: billTextBackground,
          }}
        >
          <Typography
            align="center"
            style={{ fontSize: "12px", fontWeight: "bold" }}
          >
            مبلغ قابل پرداخت
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            border: "1px solid #333333",
            borderBottomRightRadius: "8px",
          }}
        >
          <Typography
            align="center"
            style={{ fontSize: "14px", fontWeight: "bold" }}
          >
            {convertNumbers(
              moment(billInfo.value.deadline).locale("fa").format("YYYY/MM/DD")
            )}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{ border: "1px solid #333333", borderBottomLeftRadius: "8px" }}
        >
          <Typography
            align="center"
            style={{ fontSize: "14px", fontWeight: "bold" }}
          >
            {convertNumbers(Split(billInfo.value.price))}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const renderLeftSection = () => {
    return (
      <>
        {renderPriceTable()}
        {renderDeadline()}
      </>
    );
  };

  const renderBillStyle = () => {
    if (billInfoIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div
          id={"bill"}
          style={{
            paddingTop: "24px",
            paddingRight: "8px",
            paddingLeft: "8px",
            paddingBottom: "24px",
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ border: "1px solid #333333", paddingBottom: "4px" }}
            >
              {renderBillHeader()}
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ borderBottom: "1px solid #333333", height: "60px" }}
                >
                  {renderUserInfo()}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  // style={{ height: "300px" }}
                >
                  {renderRightSection()}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  // style={{ height: "300px", border: "1px solid red" }}
                >
                  {renderMiddleSection()}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={4}
                  lg={4}
                  // style={{ height: "300px", border: "1px solid red" }}
                >
                  {renderLeftSection()}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      );
    }
  };

  const renderBillInfo = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ marginBottom: "24px", marginTop: "16px" }}
        >
          <Typography style={{ fontWeight: "bold" }}>
            {convertNumbers("جزئیات قبض " + billSerial)}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            borderBottom: "1px solid #333333",
            paddingBottom: "24px",
          }}
        >
          {renderBillStyle()}
        </Grid>
      </>
    );
  };

  const renderBtns = () => {
    return (
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: "8px" }}>
        <Button
          onClick={downloadBill}
          style={{ backgroundColor: ERROR_COLOR, color: WHITE }}
        >
          دانلود قبض
        </Button>
      </Grid>
    );
  };

  return (
    <>
      <SuccessModal
        open={successModalOpen}
        title={successTitle.value}
        message={successMessage.value}
        style={successStyle.value}
      />
      <Grid
        container
        style={{
          marginTop: "64px",
          paddingTop: "16px",
          paddingBottom: "16px",
          paddingRight: "8px",
          paddingLeft: "8px",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            backgroundColor: WHITE,
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "8px",
            position: "relative",
          }}
        >
          <Box
            style={{
              maxWidth: "250px",
              marginRight: "auto",
              marginLeft: "auto",
              marginTop: "-60px",
              paddingRight: "36px",
              paddingLeft: "36px",
              paddingTop: "24px",
              paddingBottom: "24px",
              borderRadius: "12px",
              backgroundColor: GREEN_PRIMRY,
              color: WHITE,
              cursor: "pointer",
            }}
            textAlign={"center"}
          >
            <Typography style={{ fontWeight: "bold" }}>جزئیات قبض</Typography>
          </Box>
          <Grid container>
            {renderBillInfo()}
            {renderBtns()}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default BillInfo;

const processBillInfo = (info) => {
  const startDate = moment(info.bill_start_date).locale("fa");
  const endDate = moment(info.bill_create_date).locale("fa");
  const periodDays = daysBetweenDates(startDate, endDate);
  const avgConsumption = (
    Number(info.consumptions) / Number(periodDays)
  ).toFixed(2);
  const billInfo = {
    user: {
      name:
        info.bill_user_info.user_name + " " + info.bill_user_info.user_lastname,
      phoneNumber: info.bill_user_info.user_phone,
      postalCode: "-",
      address: "",
    },
    createdDate: info.bill_create_date,
    from: info.bill_start_date,
    to: info.bill_create_date,
    counterInfo: {
      serial: info.bill_water_meter.water_meter_serial,
      status: info.bill_water_meter.water_meter_activation
        ? "فعال"
        : "غیر فعال",
    },
    consumptions: info.consumptions,
    id: info.bill_id,
    serial: info.bill_serial,
    price: info.bill_price,
    deadline: info.payment_dead_line,
    periodDays: periodDays,
    avgConsumption: avgConsumption,
  };
  return billInfo;
};

const fetchBillInfo = (utils) => {
  const isLoading = utils.isLoading;
  const billInfo = utils.billInfo;
  const billSerial = utils.billSerial;
  const billId = utils.billId;

  const data = {
    bill_id: billId,
    bill_serial: billSerial,
  };

  Call("POST", "bills/admin/getOne", data)
    .then((response) => {
      // console.log("getOne bill info: ", response);
      if (response.data.code === 200) {
        billInfo.handleChange(processBillInfo(response.data.data));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};
